import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const DetailedFiltersContent = styled.div`
    padding-top: 2rem;
    padding-bottom: 2rem;

    @media only screen and (max-width: 768px) {
        grid-template-columns: 2fr 3fr;
    }
`;

export const ColumnOne = styled.div`
    margin-bottom: 1rem;
`;

export const ColumnTwo = styled.div`
    grid-column: 2;
    grid-row: 1;
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    @media only screen and (max-width: 768px) {
        display: block;
    }
`;

export const DropdownWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
`;

export const AddButton = styled(Button)`
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-right: 1rem;
    min-width: 120px;
`;

export const ResetButton = styled(Button)`
    margin-top: 1rem;
    margin-bottom: 1rem;
    margin-left: 1rem;
    margin-right: 0rem;
    min-width: 120px;
`;